import axios from 'axios'
import Swal from 'sweetalert2'

export default async function onSubmitBiodata(competency, institution, lastEducation, majors, graduationYear, gpa, biodata, history, upload, location) {
    let param = [competency, institution, lastEducation, majors, graduationYear, gpa, upload]
    let paramStr = ['Prestasi & Kompetensi', 'Institusi', 'Pendidikan Terakhir', 'Jurusan', 'Pendidikan Terakhir', 'IPK', 'Photo CV']
    let empty = []
    for (let index = 0; index < param.length; index++) {
        const element = param[index];
        if (!element) {
            empty.push(paramStr[index])
        }
    }

    if (empty.length !== 0) {
        return Swal.fire({
            icon: 'error',
            title: 'Masih belum di isi',
            text: empty.join(' , '),
        })
    }

    let gender_short = ''
    if (biodata.gender === 'Laki - Laki') {
        gender_short = 'L'
    } else if (biodata.gender === 'Perempuan') {
        gender_short = 'P'
    }

    let marital_status = {
        'Kawin': 1,
        'Cerai': 2,
        'Belum Kawin': 3
    }

    let religion = {
        'Islam': 1,
        'Katolik': 2,
        'Protestan': 3,
        'Hindu': 4,
        'Budha': 5,
        'Kepercayaan': 6,
        'Kristen': 6
    }

    async function uploadImage(upload) {
        var FormData = require('form-data');
        var data = new FormData();
        data.append('photo', upload);

        var config = {
            method: 'post',
            url: `${process.env.REACT_APP_API}/participant/biodata/upload`,
            data: data
        };

        const res = await axios(config);
        return res
    }

    var image = ''
    image = upload
    if (typeof (upload) === 'object') {
        image = await uploadImage(upload)
    }

    Swal.showLoading()
    if (location.state.exist === true) {
        console.log('masuk user exist education', location.state)
        let obj = {
            competency,
            institution,
            lastEducation,
            majors,
            graduationYear,
            gpa,
            upload: image.data
        }
        window.localStorage.setItem('education', JSON.stringify(obj));
        Swal.close()
        return history.push({
            pathname: '/biodata/working',
            state: {
                participantId: biodata.participantId, name: biodata.fullname, exist: true, getParticipant: location.state.getParticipant, getPayment: location.state.getPayment,
                payment_id: location.state.getPayment.id, is_main_user: location.state.is_main_user, countParticipant: location.state.countParticipant
            }
        })
    }

    axios.post(`${process.env.REACT_APP_API}/participant/biodata/register`, {
        participant_id: biodata.participantId,
        nik: biodata.nik,
        gender: gender_short,
        birth_place: biodata.birthPlace,
        birth_date: biodata.selectedDateBorn,
        marital_id: marital_status[biodata.marital],
        religion_id: religion[biodata.religion],
        address: biodata.address,
        kelurahan: biodata.kelurahan,
        kecamatan: biodata.kecamatan,
        kabupaten: biodata.districts.code,
        provinsi: biodata.province.iso,
        kodepos: biodata.postalCode,
        competency: competency,
        edu_institution: institution,
        edu_degree: lastEducation,
        edu_major: majors,
        edu_grad_year: graduationYear,
        edu_grade: gpa,
        photo: image.data,
        is_main_user: location.state.is_main_user,
        payment_id: location.state.payment_id
    })
        .then(function (response) {
            Swal.close()
            history.push({
                pathname: '/biodata/working',
                state: { participantId: biodata.participantId, name: biodata.fullname, payment_id: location.state.payment_id, exist: false, countParticipant: location.state.countParticipant }
            })
        })
        .catch(function (error) {
            Swal.close()
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error
            })
        })
}